module.exports = __webpack_public_path__ + "static/media/02.Foreign Tour.95773b63.JPG";